import React, {useEffect} from "react"

import { usePartenerTradeStrategy } from "../../../@shared/stores/partnerStore"
import { useChartRef } from "../../context"
import { SMA_PERIOD, SmaPeriod } from "../../enums"
import useIndicator from "../../hooks/useIndicator"
import useNewWindow from "../../hooks/useNewWindow"
import useQuote from "../../hooks/useQuote"
import useStock from "../../hooks/useStock"
import { toRatio } from "../../libraries"

export default function StockInfo({
                                    chartRef
                                  }: {
  chartRef: React.RefObject<HTMLDivElement>
}) {
  const quote = useQuote()
  const { chart } = useChartRef()
  const {
    indicator: { sma, vsma, disableVsma },
    updateRecentIndicator,
  } = useIndicator()
  const { isOpenTradeStrategy } = usePartenerTradeStrategy()

  const { contents } = useStock()
  const [graphHeight, setGraphHeight] = React.useState(0)

  const isSmaVisible = sma.findIndex((_sma) => _sma.visible) > -1

  useEffect(() => {
    setGraphHeight((chartRef.current?.offsetHeight || 0) * 0.82)
  }, [chartRef.current?.offsetHeight, isOpenTradeStrategy]);



  return (
    <>
      <div className="graph_txt type01">
        <div className="price">
          {quote && (
            <>
              <p>
                고가
                <span className="up">{quote.highPrice.toLocaleString()}</span>
              </p>
              <p>
                저가
                <span className="down">{quote.lowPrice.toLocaleString()}</span>
              </p>
              <p>
                거래량 <span>{quote.accTradeVolume.toLocaleString()}</span>
              </p>
            </>
          )}

          {contents?.parValue && (
            <p>
              액면가 <span>{contents.parValue.toLocaleString()} 원</span>
            </p>
          )}
          {(contents?.marketCap || 0) > 0 && (
            <p>
              시총 <span>{toKR(contents.marketCap)}</span>
            </p>
          )}
        </div>
        <div>
          {isSmaVisible && (
            <p
            // onClick={() => {
            //   open(
            //     '/setting',
            //     { width: 610, height: 457 },
            //     updateRecentIndicator
            //   )
            // }}
            >
              종가 단순
              {SMA_PERIOD.map((smaPeriod, index) => {
                const current = sma[index]

                return (
                  current.visible && (
                    <span key={smaPeriod} style={{ color: current.color }}>
                      {smaPeriod} ({getRecentSmaValue("main", smaPeriod)})
                    </span>
                  )
                )
              })}
            </p>
          )}
        </div>
      </div>
      <div
        className="graph_txt type02"
        style={{
          top: `${graphHeight }px`,
        }}
      >
        <div>
          {!disableVsma && (
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {SMA_PERIOD.map((smaPeriod, index) => {
                const current = vsma[index]

                return (
                  current.visible && (
                    <span key={smaPeriod} style={{ color: current.color }}>
                      {smaPeriod} ({getRecentSmaValue("volume", smaPeriod)})
                    </span>
                  )
                )
              })}
            </p>
          )}
        </div>
        <div className="gray">
          <p>
            거래량발행주수:{" "}
            <span>{contents?.listedShareCount?.toLocaleString()} 주</span>
          </p>
          <p>
            당일회전율:{" "}
            <span>
              {(
                (quote?.accTradeVolume || 0) / (contents?.listedShareCount || 1)
              ).toFixed(3)}
              %
            </span>
          </p>
        </div>
      </div>
      <div
        className="graph_txt type03"
        style={{
          top: `${graphHeight + 20 }px`,
        }}
      >
        <div className="gray">
          <p>
            거래량: <span>{quote?.accTradeVolume.toLocaleString()}</span>
          </p>
          <p>
            전일비:{" "}
            <span>{toRatio(quote?.changeRate || contents.changeRate)}%</span>
          </p>
        </div>
      </div>
    </>
  )

  function getRecentSmaValue(target: "main" | "volume", period: SmaPeriod) {
    try {
      const prefix = target === "main" ? "sma" : "vsma"
      const series = chart?.get?.(`${prefix}-${target}-${period}`)
      return Math.floor([...(series?.yData || [])].pop() as number) || "-"
    } catch (e) {
      console.error(e)
    }
  }
}

function toKR(price: number) {
  if (!price) {
    return ""
  }

  let newPrice = price
  let unit = ""

  if (price > 억) {
    newPrice = price / 억
    unit = "억"
  } else if (price > 만) {
    newPrice = price / 만
    unit = "만"
  }

  return Math.round(newPrice).toLocaleString() + ` ${unit}원`
}

const 만 = 10000
const 억 = 만 * 만
